import { useCallback, useEffect, useState } from 'react'

import noop from 'lib/function/noop'

import { CroSppCollapsedPackagesVariant } from './useCroSppCollapsedPackagesExperiment'

interface PropertyRoomPackageExpansion {
  activePackagesVariant: CroSppCollapsedPackagesVariant
  packagesExpanded: boolean
  onTogglePackages: () => void
}

export function shouldInitiallyExpandRoomPackages(
  packagesVariant: CroSppCollapsedPackagesVariant,
): boolean {
  return packagesVariant === CroSppCollapsedPackagesVariant.expanded
}

export function getActiveRoomPackagesVariant(
  packagesVariant: CroSppCollapsedPackagesVariant,
  disabled: boolean,
): CroSppCollapsedPackagesVariant {
  return disabled ? CroSppCollapsedPackagesVariant.control : packagesVariant
}

function usePropertyRoomPackageExpansion(
  packagesVariant: CroSppCollapsedPackagesVariant,
  disabled: boolean,
  onShowAllPackages: () => void = noop,
): PropertyRoomPackageExpansion {
  const initialPackagesExpanded = shouldInitiallyExpandRoomPackages(packagesVariant)
  const [packagesExpanded, setPackagesExpanded] = useState(initialPackagesExpanded)

  useEffect(() => {
    setPackagesExpanded(initialPackagesExpanded)
  }, [initialPackagesExpanded])

  const activePackagesVariant = getActiveRoomPackagesVariant(packagesVariant, disabled)

  const onTogglePackages = useCallback(() => {
    if (!packagesExpanded) {
      onShowAllPackages()
    }
    setPackagesExpanded(currentPackagesExpanded => !currentPackagesExpanded)
  }, [onShowAllPackages, packagesExpanded])

  return {
    activePackagesVariant,
    packagesExpanded,
    onTogglePackages,
  }
}

export default usePropertyRoomPackageExpansion
